module.exports = __webpack_public_path__ + "static/media/fetal-id-education-BN.37dbc4ac.png";